import { OnInit, Output, EventEmitter } from "@angular/core";
import { Component } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { DashboardService } from "../Dashboad.service";
import { YearAndQuaterDataService } from "../../employee/services/yearAndQuaterData.service";
import { EmployeeRequestsService } from "../../employee/employee-career-request/employee-career-request.service";
import { EmployeeCareerProgramService } from "../../employee/employee-career-program/employee-career-program.service";
import { User } from "../../employee/program-catalogue/program-catalogue.component";
import { FormControl, FormGroup } from "@angular/forms";
import { DatePipe } from "@angular/common";
@Component({
  selector: "app-team-program",
  templateUrl: "./team-program.component.html",
  styleUrls: ["./team-program.component.css"],
})
export class TeamProgramComponent implements OnInit {
  teamCourseColumns: string[] = ["Employee Name", "Course Name", "Status"];
  status: { [key: string]: number } = {
    All: 0,
    Completed: 2,
    Inprogress: 1,
    "Not started": 3,
  };
  dataStore: MatTableDataSource<any>[];
  userId: number;
  MyTeamCourseDetails: any;
  year: any;
  quarterNo: any;
  yearData: any;
  names = [];
  selectedStatus = [];
  name = "select by name";
  quarterData: any;
  from: any = 0;
  size: any = 10;
  totalRecords: any = 0;
  currentPage: Number = 0;
  //subscription: Subscription;
  PageNo: number = 1;
  pageSize: number = 9;
  reqData: any;
  empIds: any;
  userIds = [];
  employeeId: any;
  myUserIds: User[] = [];
  emptyData = new MatTableDataSource([{ empty: "row" }]);
  teamMembers: any;
  members: any;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  startDate: any = null;
  endDate: any = null;
  input: any;
  constructor(
    private DashboardService: DashboardService,
    private quarterAndYearData: YearAndQuaterDataService,
    private employeeCareerProgramService: EmployeeCareerProgramService,
    private datepipe: DatePipe
  ) {}

  ngOnInit() {
    let date = new Date();
    this.year = date.getFullYear();
    this.quarterNo = Math.floor(date.getMonth() / 3) + 1;
    this.userId = parseInt(localStorage.getItem("EmpCareerUserID"));
    this.employeeId = parseInt(localStorage.getItem("Id"));
    this.yearData = this.quarterAndYearData?.yearData;
    this.quarterData = this.quarterAndYearData?.quarterData;
    this.dataStore = [new MatTableDataSource<any>()];
    this.setDateBasedOnQuarterNo(this.quarterNo);
    this.range.setValue({
      start: this.startDate,
      end: this.endDate,
    });
    this.employeeCareerProgramService
      .getMyHeirarchy(this.employeeId)
      .subscribe((users: any[]) => {
        this.myUserIds = users.map((x) => x.userId);
        this.reqData = {
          userId: this.userId,
          employeeId: this.employeeId.toString(),
          quarterNo: this.quarterNo,
          year: this.year.toString(),
          startDate: this.startDate,
          endDate: this.endDate,
          pageNo: this.PageNo,
          pageSize: this.pageSize,
          userIds: this.myUserIds,
          statusIds:
            window.history.state.Status?.length > 0 &&
            window.history.state.Status !== undefined
              ? [2]
              : [1, 2, 3], //
        };
        if (
          window.history.state.Status?.length > 0 &&
          window.history.state.Status !== undefined
        ) {
          this.selectedStatus = ["Completed"];
        }
        this.getTeamProgramDetails(this.reqData);
      });
  }
  getTeamProgramDetails(model: any) {
    this.DashboardService.getMyTeamCourseDetails(model).subscribe((data) => {
      if (data !== null) {
        this.MyTeamCourseDetails = data;
        this.dataStore[0] = new MatTableDataSource<any>(
          this.MyTeamCourseDetails
        );
        this.totalRecords = this.dataStore[0].data[0]?.recordCount;
        this.empIds = this.MyTeamCourseDetails[0].employeeList.map((x) => ({
          employeeName: x.employeeName,
          userId: x.employeeId,
        }));
        let allData = this.MyTeamCourseDetails[0].employeeList.map(
          (x) => x.employeeName
        );
        this.teamMembers = allData.filter(
          (str, index, self) => index === self.indexOf(str)
        );
        this.members = this.teamMembers.slice();
      }
    });
  }
  filterByYear(val: any) {
    this.totalRecords = 0;
    this.year = val.value;
    this.reqData.year = val.value.toString();
    this.getTeamProgramDetails(this.reqData);
  }
  filterByQuarter(value: any) {
    this.totalRecords = 0;
    this.quarterNo = value.value;
    this.reqData.quarterNo = value.value;
    this.getTeamProgramDetails(this.reqData);
  }

  changePage(page: number) {
    this.PageNo = page;
    this.reqData.pageNo = page;
    this.getTeamProgramDetails(this.reqData);
  }
  filterDataByNames(event: any) {
    if (event.value.find((x) => x == "Select All")) {
      this.userIds = this.empIds.map((employee) => employee.userId);
    } else {
      this.userIds = this.empIds
        ?.filter((employee) => this.names.includes(employee.employeeName))
        .map((employee) => employee.userId);
    }
    if (this.userIds.length == 0) {
      this.userIds = this.myUserIds;
    }
    this.reqData.userIds = this.userIds;
    this.getTeamProgramDetails(this.reqData);
  }
  filterDataByStatus(event: any) {
    let result: number[] = event.reduce((acc, item) => {
      if (this.status.hasOwnProperty(item)) {
        acc.push(this.status[item]);
      }
      return acc;
    }, []);
    if (result.length <= 0 || event.find((x) => x == "All")) {
      result = [1, 2, 3];
    }
    this.reqData.statusIds = result;
    this.getTeamProgramDetails(this.reqData);
  }
  onSearch(value: any) {
    this.input = value;
    this.teamMembers = this.search(value);
  }

  search(value: any) {
    let filter = value.toLowerCase();
    let filteredlist = this.members.filter((option) =>
      option.toLowerCase().includes(filter)
    );
    if (filteredlist.length == 0) {
      return this.teamMembers;
    } else {
      return filteredlist;
    }
  }
  clearSearch() {
    this.input = "";
    this.teamMembers = this.empIds.map((emp) => emp.employeeName);
  }
  clear() {
    this.totalRecords = 0;
    this.names = null;
    this.reqData.userIds = this.myUserIds;
    this.getTeamProgramDetails(this.reqData);
  }

  applyDateRange() {
    this.reqData.startDate = this.startDate;
    this.reqData.endDate = this.endDate;
    this.getTeamProgramDetails(this.reqData);
  }

  clearDateRange() {
    this.startDate = null;
    this.endDate = null;
    this.dataStore[0] = null;
  }

  setDateBasedOnQuarterNo(quarterNo) {
    let today = new Date();
    switch (quarterNo) {
      case 1:
        this.startDate = new Date(today.getFullYear(), 0, 1);
        this.endDate = new Date(today.getFullYear(), 2, 31);
        break;
      case 2:
        this.startDate = new Date(today.getFullYear(), 3, 1);
        this.endDate = new Date(today.getFullYear(), 5, 30);
        break;
      case 3:
        this.startDate = new Date(today.getFullYear(), 6, 1);
        this.endDate = new Date(today.getFullYear(), 8, 30);
        break;
      case 4:
        this.startDate = new Date(today.getFullYear(), 9, 1);
        this.endDate = new Date(today.getFullYear(), 11, 31);
        break;
    }
    this.startDate =
      this.datepipe.transform(this.startDate, "yyyy-MM-ddTHH:mm:ss.SSS") + "Z";
    this.endDate =
      this.datepipe.transform(this.endDate, "yyyy-MM-ddTHH:mm:ss.SSS") + "Z";
  }
}
